import WelcomeSection from './components/welcome-section';
import { Heading } from 'components/text';

import VaultBenefits from './components/vault-benefits';
import styles from './PartnerWithUs.module.scss';
import Image from 'next/image';
import partnerWithUsHeroImg from 'assets/partner-with-us/partner-with-us-body.png';
import { emailAdresses } from 'data/constants';

import Container from 'components/container';

const PartnerWithUs: React.FC<{}> = ({}) => {
  return (
    <Container className={styles.container}>
      <WelcomeSection />
      <section className={styles.heroImage}>
        <Image
          priority
          src={partnerWithUsHeroImg}
          alt="Partner with us hero image"
          layout="responsive"
        />
      </section>
      <VaultBenefits />
      <section className={styles.contactSection}>
        <div className={styles.contactWrapper}>
          <Heading as="h5">
            To find out more and to discuss your eligibility for this
            programme,&nbsp;
            <span className={styles.contactText}>please contact us</span>
          </Heading>
          <a
            className={styles.container}
            href={`mailto:${emailAdresses.PARTNER_WITH_US}`}
            target="_blank"
            rel="noreferrer"
          >
            <Heading as="h5" weight="regular">
              {emailAdresses.PARTNER_WITH_US}
            </Heading>
          </a>
        </div>
      </section>
    </Container>
  );
};

export default PartnerWithUs;
